import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/* eslint-disable new-cap */
export default class ProgressMeter {
  constructor(game, numLevels) {
    this.game = game;
    this.progressPoints = [];
    this.progressLines = [];
    this.numLevels = numLevels;
    this.curLevel = 0;

    const pointSpace = 45;
    const pointWidth = 45;
    const startX = game.scale.width * .5 + 30 + (((numLevels * pointWidth) + ((numLevels - 1) * pointSpace)) * -.5);
    const scale = 1;
    const posY = 60;

    for (let i = 0; i < numLevels; i++) {
      if (i < (numLevels - 1)) {
        const progressPoint = game.add.sprite(startX + (i * pointWidth) + (i * pointSpace), posY, Images.DEFAULT_ATLAS, 'meter_RedDot');
        progressPoint.setOrigin(.5);
        progressPoint.setScale(scale);
        this.progressPoints.push(progressPoint);
      }

      if (i > 0) {
        const progressLine = game.add.sprite(startX + (i * pointWidth) + ((i - 1) * pointSpace), posY, Images.DEFAULT_ATLAS, 'meter_RedBar');
        progressLine.setOrigin(.5);

        // progressLine.setScale(scale);
        this.progressLines.push(progressLine);
      }

    }

    this.bonusStar = game.add.sprite(startX + ((numLevels - 1) * pointWidth) + ((numLevels - 1) * pointSpace), posY - 4, Images.DEFAULT_ATLAS, 'meter_Star');
    this.bonusStar.setOrigin(.5);
    this.bonusStar.setScale(scale);

    this.rocket = game.add.sprite(this.progressPoints[0].x, posY, Images.DEFAULT_ATLAS, 'meter_Rocket');
    this.rocket.setOrigin(.5);
    this.rocket.setScale(scale);
  }

  SetLevel(level) {
    this.curLevel = level;
    if (level === 6) this.bonusStar.destroy();
    const nextX = this.nextPosX();
    this.setState();
    this.rocket.x = nextX;
  }

  NextLevel() {
    this.curLevel++;
    const nextX = this.nextPosX();
    this.setState();
    Tweens.addTween(this.rocket, 5000, { x: nextX }, Phaser.Math.Easing.Exponential);
  }

  setState() {
    for (let i = 0; i < this.curLevel; i++) {
      if (i < (this.curLevel - 1)) {
        this.progressPoints[i].setFrame('meter_GreenDot');
      }
      if (i > 0) {
        this.progressLines[i - 1].setFrame('meter_GreenBar');
      }
    }
  }

  nextPosX() {
    if (this.LevelsLeft() === 0) {
      return this.bonusStar.x;
    }
    else {
      return this.progressPoints[this.curLevel - 1].x;
    }
  }

  LevelsLeft() {
    return this.numLevels - this.curLevel;
  }
}


